import React, { useMemo, useState, useRef } from "react";
import Modal from "../modal/modal";
import Title from "../../components//title-tile/titleTileComponent";
import survey from "../../utils/survey";

function normalizeToEmbed(url) {
  try {
    const u = new URL(url);
    if (u.pathname.includes("/viewform") && !u.searchParams.get("embedded")) {
      u.searchParams.set("embedded", "true");
    }
    // Force to be spanish
    u.searchParams.set("hl", "es");
    return u.toString();
  } catch {
    return url;
  }
}

function appendPrefill(url, prefill) {
  if (!prefill || typeof prefill !== "object") return url;
  try {
    const u = new URL(url);
    Object.entries(prefill).forEach(([k, v]) => {
      if (v !== undefined && v !== null) u.searchParams.set(k, String(v));
    });
    return u.toString();
  } catch {
    return url;
  }
}

export default function GoogleFormModal({
  show,
  setShow,
  id = "google-form-modal",
  title = '',
  formUrl,
  height = 700,
  prefill,
  closeButton = false,
  dismissible = false,
  survey: surveyObj = null,
  user = null
}) {
  const embedUrl = useMemo(() => {
    const base = normalizeToEmbed(formUrl);
    return appendPrefill(base, prefill);
  }, [formUrl, prefill]);

  const loadCountRef = useRef(0);

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleLoad = async () => {
    loadCountRef.current += 1;
    if (loadCountRef.current > 1) {
      // Save user as responded to the survey
      if (surveyObj && user && user._id) {
        try {
          await survey.addResponseId(surveyObj.surveyNumber, { userId: user._id });
          setSuccess(true);
          setShow(false);
          window.location.reload();
        } catch (e) {
          setError("Ocurrió un error al registrar la respuesta del usuario.");
        }
      }
    }
  };

  return (
    <Modal
      show={show}
      setShow={setShow}
      title={title}
      closeButton={success ? true : closeButton}
      id={id}
      embeddings={true}
      footer={dismissible && (
        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">
            Si no ves el formulario,&nbsp;
            <a href={embedUrl} target="_blank" rel="noopener noreferrer">
              abrilo en una pestaña nueva
            </a>.
          </small>
        </div>
      )}
    >
      <>
        {error && (
          <div className="alert alert-danger my-2" role="alert">
            {error}
          </div>
        )}
        {success && (
          <div className="text-center my-4">
            <Title message="Muchas Gracias por completar la encuesta!" theme="success" />
          </div>
        )}
        {!success && (
          <div>
            <iframe
              title={title}
              src={embedUrl}
              style={{ width: "100%", height, border: 0 }}
              loading="lazy"
              allowFullScreen={true}
              onLoad={handleLoad}
            />
          </div>
        )}
      </>
    </Modal>
  );
}
